(function () {
  'use strict';

  // Fully self-contained: no shared state with harness-buy-box.js, no cart
  // or variant logic — just switches which tab/panel pair is visible.
  function initTabs(section) {
    const tabs = Array.from(section.querySelectorAll('[data-pit-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-pit-panel]'));
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(i));
    });
  }

  // Independent from initTabs above — its own click listeners, no shared
  // state. Each row toggles open/closed on its own; opening one does not
  // close the others.
  function initAccordion(section) {
    const items = Array.from(section.querySelectorAll('.pit__accordion-item'));
    items.forEach((item) => {
      const trigger = item.querySelector('[data-pit-accordion-trigger]');
      const panel = item.querySelector('[data-pit-accordion-panel]');
      if (!trigger || !panel) return;
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.hidden = isOpen;
      });
    });
  }

  // ---------------------------------------------------------------------
  // Desktop-only positioning fix: this section is visually docked under
  // harness-buy-box's own right-hand column (title/description/guarantee),
  // but the two are separate Shopify sections stacked normally in the
  // document — this section's natural top is wherever harness-buy-box's
  // TALLER side (usually the gallery) ends, not where the shorter buybox
  // column's text ends. That left a large empty gap above the tabs. This
  // pulls the section up with a negative margin equal to that gap, purely a
  // read of harness-buy-box's rendered position — nothing is written into
  // that section's own DOM/JS, only this section's own margin is changed.
  function alignUnderBuybox(section) {
    if (window.innerWidth < 990) {
      section.style.marginTop = '';
      return;
    }
    const buybox = document.querySelector('.hbb__buybox');
    if (!buybox) return;
    section.style.marginTop = '';
    const gap = section.getBoundingClientRect().top - buybox.getBoundingClientRect().bottom;
    if (gap > 0) section.style.marginTop = '-' + gap + 'px';
  }

  document.querySelectorAll('.pit').forEach((section) => {
    initTabs(section);
    initAccordion(section);

    alignUnderBuybox(section);
    window.addEventListener('load', () => alignUnderBuybox(section));
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => alignUnderBuybox(section), 150);
    });
  });
})();
